import React from "react"
import { FormSelect, FormTime, FormMoney } from "@myxplor/forms"
import { feeTypes, feeIsHourly } from './helpers'

const CasualSession = ({
  session,
  onChange,
  nameBase,
  careEnrolmentOptions
}) => {
  const isHourlySession = feeIsHourly(session.feeFrequency)
  
  return (
    <div>
      <h4>Casual Session</h4>
      <fieldset>
        <FormTime
          key="start_time"
          name={nameBase + '.startTime'}
          label="Start"
          value={session.startTime}
          onChange={onChange}
          compact
          required
        />
        <FormTime
          key="end_time"
          name={nameBase + '.endTime'}
          label="Finish"
          value={session.endTime}
          onChange={onChange}
          compact
          required
        />

        <FormSelect
            name={nameBase + '.feeFrequency'}
            label="Frequency"
            options={feeTypes}
            value={session.feeFrequency || feeTypes[0].value}
            onChange={onChange}
          />

          <FormMoney
            name={nameBase + '.standardAmount'}
            value={session.standardAmount}
            onChange={onChange}
            label={`Cost per ${isHourlySession ? 'hour' : 'session'}`}
            compact
            required
          />

        {careEnrolmentOptions.length > 1 && (
          <FormSelect
            name={nameBase + '.care_id'}
            options={careEnrolmentOptions}
            value={session.care_id}
            label="Care Profile"
            onChange={onChange}
            compact
            required
          />
        )}
      </fieldset>
    </div>
  )
}

export default CasualSession



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/actions/update-enrolment-schedule/form/casual-session.jsx